import type { AppScannerEnvironment } from './environment.scanner';
import { DEFAULT_SCANNER_DRIVER_LINKS } from './environment.scanner';

/** Local / `ng serve` default. Production deploy uses `environment.prod.ts` via `ng build --configuration=production`. */
export const environment = {
  production: false,
  disableConsole: false,
  appVersion: '1.5.2.74',

  // API target — keep only one apiUrl uncommented:
  // Production:  'https://backend.isamed.ai/api/v1'
  // Staging:     'https://stag-isamed.mobiloitte.io/api/v1'
  // Local Go:    'http://localhost:8073/api/v1'  (must match SERVER_PORT in backend .env)
  apiUrl: 'https://stag-isamed.mobiloitte.io/api/v1',

  useSnakeCaseForAttachedDocuments: true,

  scanner: {
    enabled: true as boolean,
    useDevProxy: true,
    healthUrl: 'http://127.0.0.1:9879',
    esclUrl: 'http://127.0.0.1:9880/eSCL',
    installerUrlWin: '',
    installerUrlMac: '',
    scannerDriverHelpUrl: '',
    scannerDriverLinks: { ...DEFAULT_SCANNER_DRIVER_LINKS },
    naps2: {
      esclHost: '127.0.0.1',
      esclPorts: [9880],
      healthPort: 9879,
      useDevProxy: true,
      healthProxyPath: '/naps2-health',
      esclProxyPath: '/naps2-escl'
    },
    webcamScanEnabled: false as boolean
  } satisfies AppScannerEnvironment
};
